export const isValidPAN = (panNumber) => {
    panNumber = panNumber.replace(/\s/g, '');

    if (panNumber.length !== 10) {
        return false;
    }

    var panRegex = /^([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
    if (!panRegex.test(panNumber)) {
        return false;
    }

    return true;
};


export const isValidGST = (gstNumber) => {
    gstNumber = gstNumber.replace(/\s/g, '');

    if (gstNumber.length !== 15) {
        return false;
    }

    var gstRegex = /^([0-9]){2}([A-Z]){5}([0-9]){4}([A-Z]){1}([0-9A-Z]){3}$/;
    if (!gstRegex.test(gstNumber)) {
        return false;
    }

    return true;
};


export const isValidURN = (urnNumber) => {
    urnNumber = urnNumber.replace(/\s/g, '');
    
    if (urnNumber.length < 16) {
        return false;
    }
    
    var urnRegex = /^[0-9a-z]{16}$/;
    if (!urnRegex.test(urnNumber)) {
        return false;
    }

    return true;
};




export const isValidAadhaar = (aadhaarNumber) => {
    aadhaarNumber = aadhaarNumber.replace(/\s/g, '');

    if (aadhaarNumber.length !== 12) {
        return false;
    }

    var aadhaarRegex = /^[0-9]{12}$/;
    if (!aadhaarRegex.test(aadhaarNumber)) {
        return false;
    }

    return true;
};


export const isValidTIN = (tinNumber) => {
    tinNumber = tinNumber.replace(/\s/g, '');

    if (tinNumber.length !== 11) {
        return false;
    }

    var tinRegex = /^\d{11}$/;
    if (!tinRegex.test(tinNumber)) {
        return false;
    }

    return true;
};


export const isValidPassport = (passportNumber) => {
    passportNumber = passportNumber.replace(/\s/g, '');

    if (passportNumber.length < 6 || passportNumber.length > 10) {
        return false;
    }

    var passportRegex = /^[A-Z0-9]+$/;
    if (!passportRegex.test(passportNumber)) {
        return false;
    }

    return true;
};


export const isValidElectorID = (electorID) => {
    electorID = electorID.replace(/\s/g, '');

    if (electorID.length !== 10) {
        return false;
    }

    var electorIDRegex = /^[A-Z]{2}\d{7}$/;
    if (!electorIDRegex.test(electorID)) {
        return false;
    }

    return true;
};


export const isValidDrivingLicense = (drivingLicenseNumber) => {
    drivingLicenseNumber = drivingLicenseNumber.replace(/\s/g, '');

    if (drivingLicenseNumber.length < 6 || drivingLicenseNumber.length > 20) {
        return false;
    }

    var drivingLicenseRegex = /^[A-Z0-9]+$/;
    if (!drivingLicenseRegex.test(drivingLicenseNumber)) {
        return false;
    }

    return true;
};


export const isValidRationCard = (rationCardNumber) => {
    rationCardNumber = rationCardNumber.replace(/\s/g, '');

    if (rationCardNumber.length < 8 || rationCardNumber.length > 15) {
        return false;
    }

    var rationCardRegex = /^[A-Z0-9]+$/;
    if (!rationCardRegex.test(rationCardNumber)) {
        return false;
    }

    return true;
};


export const convertEditDateFormat = (dateStr) => {
    const parts = dateStr.split('/');
    const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
    return formattedDate;
}